<template>
  <a-drawer
    placement="right"
    :visible="visible"
    :closable="true"
    :mask-closable="false"
    width="800"
    wrap-class-name="edm-contact-filter-drawer"
    @close="onClose"
  >
    <div
      slot="title"
      class="title clearfix"
    >
      <h2 class="fl">
        筛选
      </h2>
      <span
        class="more-btn btn-text fl"
        @click="openFilterConfig"
      >更多筛选条件</span>
    </div>

    <a-spin
      :spinning="loading"
      class="form"
    >
      <a-form
        v-if="!loading && newFormData && newFormData.length"
        :form="form"
        :hide-required-mark="true"
      >
        <filter-item
          v-for="(item) in newFormData"
          :key="item.fileldkey"
          class="clearfix"
          :data="item"
          @change="onChangeItem"
        />
      </a-form>
    </a-spin>
    <div class="footer">
      <a-button
        type="primary"
        @click="handleOk"
      >
        确定
      </a-button>
      <a-button
        :style="{marginRight: '8px'}"
        @click="handleClear"
      >
        清除选项
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getEncode } from '@/lib/mix'
import { setCodeData, jsonToBase64, base64ToJson } from '@/lib/utils'
const FilterItem = () => import('@/pc/inquery/filterItem/FilterItem')

export default {
  components: {
    FilterItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    contactid: {
      type: [String, Number],
      default: ''
    }
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      isVisible: false,
      search: {}
    }
  },
  computed: {
    ...mapState('edm/filterData', ['filterFormData', 'loading', 'filterResult', 'filterStr']),

    query () {
      return this.$route.query
    },

    newFormData () {
      if (this.$toType(this.filterFormData) !== 'array') return
      for (let item of this.filterFormData) {
        const { fieldkey } = item
        for (let key in this.filterResult) {
          if (fieldkey === key) {
            if (item.isneeded === 1) {
              item.isneeded = 0
            }

            let value = this.filterResult[key] && this.filterResult[key].fieldvalue
            // item.fieldvalue = this.filterResult[key]
            this.$set(item, 'fieldvalue', value)
          }
        }
        if (!Object.keys(this.filterResult).length) {
          for (let item of this.filterFormData) {
            item.fieldvalue = ''
          }
        }
      }
      return this.filterFormData
    },
    filters () {
      let filters = {}
      if (this.filterStr) {
        filters = base64ToJson(this.filterStr)
        // 将结果放到store
        this.setFilterResult(filters)
      } else {
        this.setFilterResult({})
      }

      return filters
    }
  },
  watch: {
    async visible (val) {
      this.isVisible = val
      if (val) {
        this.$nextTick(() => {
          this.fetchQuery()
          /* if (this.filterStr) {
            this.setFilterResult(base64ToJson(this.filterStr))
          } */
          document.body.style.overflow = 'hidden'
        })
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  },

  created () {
    this.$bus.$on('getEdmQuery', this.fetchQuery)
  },
  beforeDestroy () {
    this.$bus.$off('getEdmQuery')
  },

  methods: {
    ...mapActions('edm/filterData', ['fetchQuery', 'fetchEdmQueryCount', 'setEdmQueryResult', 'setFilterResult', 'setFilterStr']),

    onChangeItem (value) {
      // console.log(value)
    },
    hide () {
      this.$emit('update:visible', false)
      this.setFilterResult({})
      this.$bus.$emit('clearCheckedKeys')
    },
    onClose () {
      this.hide()
      // this.handleClear()
    },

    // 点击筛选的确定按钮时，处理数据为 key: value 格式
    setFilterUrlData (type) {
      let obj = {}
      for (let item of this.filterFormData) {
        let one = {}
        one.fieldtype = item.fieldtype
        one.fieldkey = item.fieldtype
        one.fieldvalue = item.fieldvalue
        if (item.fieldtype === 'radioinfo_type') {
          const { fieldconfig = {} } = item || {}
          const { info_sign: infoSign = {} } = fieldconfig
          one.info_sign = infoSign.fieldvalue
        }
        obj[item.fieldkey] = one
      }
      return obj
    },

    async handleOk () {
      // 存 store
      const urlFilters = this.setFilterUrlData()
      this.setFilterStr(jsonToBase64(urlFilters))
      if (this.filterStr) {
        this.search = await this.setFilterRequestParams(this.filters)
      }
      let chain = await this.fetchEdmQueryCount({
        search: this.search
      })
      chain.onSuccess((res = '') => {
        let num = res || 0
        this.confrimResult(num)
        this.hide()
      })
    },
    // 点击筛选的确定按钮时，处理数据为 key: value 格式
    async setFilterRequestParams (filter) {
      let obj = {}
      const enCode = await getEncode()
      for (let fieldkey in filter) {
        const item = filter[fieldkey]
        switch (item.fieldtype) {
          case 'text':
          case 'phone':
          case 'email':
          case 'editor':
          case 'tag':
            obj[fieldkey] = await setCodeData(item.fieldvalue, enCode)
            break
          case 'area':
            obj[fieldkey] = item.fieldvalue && Object.keys(item.fieldvalue)
            break
          case 'select_tree':
            obj[fieldkey] = item.fieldvalue && Object.keys(item.fieldvalue)
            break
          case 'from_info':
            let { fieldvalue = [] } = item

            let arr = []
            for (let i in fieldvalue) {
              let fields = fieldvalue[i] || []

              let one = {}
              let len = fields.length

              if (len === 1) {
                one['from_info.from'] = fields[0].fieldkey
              } else if (len === 2) {
                let fieldItem = fields[1] || {}
                one[fieldItem.fieldkey] = fields[1].inputVal
              } else if (len === 3) {
                let fieldItem = fields[1] || {}
                one[fieldItem.fieldkey] = fields[2].id
              }
              if (Object.keys(one).length) {
                arr.push(one)
              }
            }

            obj[fieldkey] = arr
            break
          case 'selectrolegroup':
          case 'selectuser':
            let res = item.fieldvalue || []
            for (let j in res) {
              let one = res[j]
              for (let k in one) {
                if (k === '_id') {
                  delete one[k]
                }
              }
            }
            obj[fieldkey] = res
            break
          case 'selectfollowuser':
            let values = item.fieldvalue || {}
            let users = values.follow_userid || []
            for (let j in users) {
              let one = users[j]
              for (let k in one) {
                if (k === '_id') {
                  delete one[k]
                }
              }
            }
            obj[fieldkey] = values
            break
          case 'radioinfo_type':
            obj['base_info.info_sign'] = item.info_sign
            obj[fieldkey] = item.fieldvalue
            break
          default:
            obj[fieldkey] = item.fieldvalue
            break
        }
      }
      return obj
    },
    confrimResult (num = 0) {
      let _this = this
      this.$confirm({
        title: <div>共筛选出 {num} 条联系人</div>,
        content: '将其添加至当前清单？',
        closable: true,
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        class: 'confirm-success-modal',
        onOk: async () => {
          let chain = await _this.setEdmQueryResult({
            contactid: this.contactid,
            search: _this.search
          })
          chain.onSuccess(res => {
            _this.$router.push({
              name: 'EditContactList',
              query: {
                _t: new Date().getTime(),
                page: 1,
                limit: 10
              }
            })
          })
        }
      })
    },
    handleClear () {
      this.$router.push({
        name: 'EditContactList',
        query: {
          _t: new Date().getTime(),
          page: 1,
          limit: 10
        }
      })

      this.setFilterStr('')
      this.setFilterResult({})
      // eventBus.$emit('fetchInquiryList')
      this.hide()
    },
    openFilterConfig () {
      this.$emit('handleConfigModal', true)
    }
  }
}
</script>

<style lang="scss">
.edm-contact-filter-drawer {
  .ant-drawer-close {
    top: 44px;
    right: 40px;
    .ant-drawer-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 32px;
      color: #ccc;
    }
  }
  .ant-drawer-content-wrapper {
    overflow-y: auto;
  }
  .ant-drawer-content {
    border-bottom: none;
  }
  .ant-drawer-header {
    padding: 32px 40px 40px;
    border-bottom: none;
  }
  .ant-drawer-title h2 {
    font-size: 32px;
    height: 56px;
    line-height: 56px;
    font-weight: 600;
  }
  .ant-drawer-body {
    padding: 0 40px 70px;
  }
  .more-btn {
    margin: 24px 0 0 16px;
    font-size: 14px;
  }
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99;
    width: 783px;
    padding: 16px 0 16px 180px;
    background-color: #fff;
    border-top: 1px solid $gray4;
  }
}
</style>
